var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { useBlocker, useLoaderData } from 'react-router-dom';

import { useSetAtom } from 'jotai';
import { FetchResponseError } from "../../../../../shared/JSONRequest";

import { Translate } from "../../../../I18N";
import * as settingsAPI from "../../../api/settings";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, Tabs } from "../../../Components/UI";
import { CodeEditor } from "../../../Components/CodeEditor";
import { ConfirmNavigationModal } from "../../../Components/Forms";
import { notificationAtom } from "../../../atoms";



const customisationLoader =
(headers) =>
async () => {
  const { allowcustomJS, customCSS, customJS } = await settingsAPI.get(headers);
  return { allowcustomJS, customCSS, customJS };
};

const Customisation = () => {
  const { allowcustomJS, customCSS, customJS } = useLoaderData();
  const [newCSS, setNewCSS] = useState(undefined);
  const [newJS, setNewJS] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const blocker = useBlocker(hasChanges);
  const setNotifications = useSetAtom(notificationAtom);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
    }
  }, [blocker]);

  const handleSave = async () => {
    if (newCSS || newJS) {
      const response = await settingsAPI.save({ customCSS: newCSS, customJS: newJS });

      if (response instanceof FetchResponseError) {
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
          details: response.message
        });
      } else {
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Saved successfully.")
        });
        setHasChanges(false);
      }
    }
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "tw-content", style: { width: '100%', height: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: allowcustomJS ? 'Global CSS & JS' : 'Global CSS' }), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0,
    allowcustomJS ? /*#__PURE__*/
    _jsx(Tabs, { unmountTabs: false }, void 0, /*#__PURE__*/
    _jsx(Tabs.Tab, { id: "css", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Custom CSS") }, void 0, /*#__PURE__*/
    _jsx(CodeEditor, {
      language: "css",
      intialValue: customCSS,
      onMount: (editor) => {var _editor$getModel;
        (_editor$getModel = editor.getModel()) === null || _editor$getModel === void 0 ? void 0 : _editor$getModel.onDidChangeContent(() => {
          setHasChanges(true);
          setNewCSS(editor.getValue());
        });
      } }
    )
    ), /*#__PURE__*/

    _jsx(Tabs.Tab, { id: "js", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Custom JS") }, void 0, /*#__PURE__*/
    _jsx(CodeEditor, {
      language: "javascript",
      intialValue: customJS,
      onMount: (editor) => {var _editor$getModel2;
        (_editor$getModel2 = editor.getModel()) === null || _editor$getModel2 === void 0 ? void 0 : _editor$getModel2.onDidChangeContent(() => {
          setHasChanges(true);
          setNewJS(editor.getValue());
        });
      } }
    )
    )
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex flex-col gap-4 pb-4 h-full" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "font-medium" }, void 0, "Custom CSS"), /*#__PURE__*/
    _jsx("div", { className: "grow" }, void 0, /*#__PURE__*/
    _jsx(CodeEditor, {
      language: "css",
      intialValue: customCSS,
      onMount: (editor) => {var _editor$getModel3;
        (_editor$getModel3 = editor.getModel()) === null || _editor$getModel3 === void 0 ? void 0 : _editor$getModel3.onDidChangeContent(() => {
          setHasChanges(true);
          setNewCSS(editor.getValue());
        });
      } }
    )
    )
    )

    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "text-end" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "solid",
      color: "success",
      disabled: !hasChanges,
      onClick: async () => handleSave() }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    ),

    showModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowModal, onConfirm: blocker.proceed })

    ));

};

export { Customisation, customisationLoader };